import { DateRangeInput, TodoType } from "@acto/gql/graphql";
import { useTeamEmployees } from "./useTeamEmployees";

interface UseSingleEmployeeOptions {
  employeeId: string;
  dateRange: DateRangeInput;
  todoTypes?: TodoType[];
  withAppointments?: boolean;
  withAppointmentStates?: boolean;
  withMarkedDone?: boolean;
}

export function useSingleEmployee({
  employeeId,
  dateRange,
  todoTypes,
  withAppointments,
  withAppointmentStates,
  withMarkedDone,
}: UseSingleEmployeeOptions) {
  const {
    data: employees,
    isPending,
    isFetching,
    error,
  } = useTeamEmployees({
    dateRange,
    pageSize: 1,
    employeeId,
    todoTypes,
    withAppointments,
    withAppointmentStates,
    withMarkedDone,
  });

  const employee = employees?.[0] ?? null;

  return {
    employee,
    isPending,
    isFetching,
    error,
  };
}
